// import { Header, Chat } from "../layouts";
// import { useLocation, Outlet } from "react-router-dom";
// import styles from "./styles.module.css";

// const AdminLayout = () => {
//   const { pathname } = useLocation();

//   let backgroundColor = "#fff";

//   if (pathname === "/") {
//     backgroundColor = "#fcfcfc";
//   }

//   return (
//     <>
//     <div  style={{ backgroundColor, maxWidth:"1140px", margin: "0 auto" }}>
//     <Header />
//       <div className={styles.content} style={{ backgroundColor}}>
//         <Outlet />
//       </div>
//       <Chat />
//     </div>
//     </>
//   );
// };

// export default AdminLayout;

import { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { Header } from "../layouts";
import Loading from "./Loading";
import { GlobalContext } from "../lib/context";

const AdminLayout = () => {
  // const { auth, loading } = useContext(GlobalContext);

  // return loading ? (
  //   <Loading />
  // ) : auth ? (
  //   <>
  //     <Header />
  //     <Outlet />
  //     {/* Auth is true */}
  //   </>
  // ) : (
  //   <Navigate to="/auth/signin" />
  // );
  const { auth, loading, profile } = useContext(GlobalContext);

//   if (loading) {
//     return <Loading />;

//   }

//   return auth ? <>
//   <Header />
//   <Outlet />
// </> : <Navigate to="/cxspsa/auth/signin" />

  // return loading ? (
  //   <Loading />
  // ) : auth ? (
  //   profile.user_role === "Admin" ? <>
  //   <Header />
  //   <Outlet />
  //   {/* Auth is true */}
  // </> : <Navigate to="/cxspsa" />
  // ) : (
  //   <Navigate to="/cxspsa/auth/signin" />
  // );
  return loading ? (
    <Loading />
  ) : auth ? (
    profile.user_role === "Admin" ? (
      <>
        <Header />
        <Outlet />
        {/* Authenticated as Admin */}
      </>
    ) : (
      // Redirect normal users to "ylot.com/psa"
      (():any => {
        window.location.href = `${process.env.REACT_APP_PSA_URL || ""}/`;

        
        return null; // Prevent rendering further React components
      })()
    )
  ) : (
    // If not authenticated, redirect to sign-in
    <Navigate to="/cxspsa/auth/signin" />
  );
  

};

export default AdminLayout;